import React from 'react';
import { cn } from '@/lib/utils';

interface DragHandleProps {
  className?: string;
  isDragging?: boolean;
}

const DragHandle: React.FC<DragHandleProps> = ({ 
  className,
  isDragging = false 
}) => {
  return (
    <div 
      className={cn(
        "flex items-center justify-center h-10 w-8 cursor-grab active:cursor-grabbing hover:bg-muted/50 transition-colors",
        isDragging && "cursor-grabbing",
        className
      )}
      title="Kéo thả để sắp xếp"
    >
      <div className="flex flex-col gap-0.5">
        <div className="flex gap-0.5">
          <div className="w-0.5 h-0.5 bg-muted-foreground/40 rounded-full transition-all group-hover:bg-muted-foreground group-hover:w-1 group-hover:h-1"></div>
          <div className="w-0.5 h-0.5 bg-muted-foreground/40 rounded-full transition-all group-hover:bg-muted-foreground group-hover:w-1 group-hover:h-1"></div>
          <div className="w-0.5 h-0.5 bg-muted-foreground/40 rounded-full transition-all group-hover:bg-muted-foreground group-hover:w-1 group-hover:h-1"></div>
        </div>
        <div className="flex gap-0.5">
          <div className="w-0.5 h-0.5 bg-muted-foreground/40 rounded-full transition-all group-hover:bg-muted-foreground group-hover:w-1 group-hover:h-1"></div>
          <div className="w-0.5 h-0.5 bg-muted-foreground/40 rounded-full transition-all group-hover:bg-muted-foreground group-hover:w-1 group-hover:h-1"></div>
          <div className="w-0.5 h-0.5 bg-muted-foreground/40 rounded-full transition-all group-hover:bg-muted-foreground group-hover:w-1 group-hover:h-1"></div>
        </div>
      </div>
    </div>
  );
};

export default DragHandle;